import { render, staticRenderFns } from "./BerthViewData.vue?vue&type=template&id=66edfb6e&scoped=true&"
import script from "./BerthViewData.vue?vue&type=script&lang=js&"
export * from "./BerthViewData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66edfb6e",
  null
  
)

export default component.exports